import React from 'react'
import { Label, Card, Image } from 'semantic-ui-react'
import Labels from '../../common/Labels'
import _ from 'lodash'
import EllipsisTooltip from '../../common/EllipsisTooltip'

const StringComponent = (key, value) => {
    return <Labels
        name={_.startCase(key)}
        text={<div dangerouslySetInnerHTML={{ __html: value }} />} />
}

const ArrayComponent = (key, Arr) => {
    let result = <Labels
        name={_.startCase(key)}
        text={<Card.Group style={{ "padding": "12px 5px" }}>
            {Arr && Arr[0] && Arr.map((d, i) => {
                if (typeof d === 'object') {
                    return UserComponent(d)
                } else {
                    return ArrOfString(d)
                }
            })}
        </Card.Group>} />


    return result
}
const ArrOfString = (d) => {
    return <Label style={{ padding: "5px", background: "#597B8A", color: "#fff" }}>{d}</Label>
}

const UserComponent = (d) => {
    let userResult = <Card className="userListCard" >
        <Card.Content >
            <Image
                style={{ objectFit: "cover", float: "left" }}
                avatar src={d.image}
                onError={this.brokenUserImage} />
            <Card.Header>
                <EllipsisTooltip
                    name={d.name} />
            </Card.Header>
            <Card.Meta className="f_10"
                style={{
                    float: 'left',
                    width: 'calc(100% - 50px)'
                }}>{d.email}</Card.Meta>
        </Card.Content>
    </Card>

    return userResult
}

const MetaDatareadonlyView = ({ metaData }) => {

    let result = <div>
        {metaData && Object.entries(metaData).map((entry, i) => {
            if (typeof (entry[1]) === "object") {
                return ArrayComponent(entry[0], entry[1])
            } if (typeof (entry[1]) === "boolean") {
                return null
            } else {
                return StringComponent(entry[0], entry[1])
            }
        })}
    </div>
    return result
}

export default MetaDatareadonlyView